import React from "react";
import { Select } from "../inputs/select";

const yesNoOptions = [
    {
        value: "",
        text: "-- Select --",
    },
    {
        value: true,
        text: "Yes",
    },
    {
        value: false,
        text: "No",
    },
];

export const YesNoBoolean = (props) => {
    return <Select {...props} excludeSelect={true} options={yesNoOptions} />;
};
